<template style="height: 100%;">
  <div class="Consultingadd CommonContentSingle-white">
    <el-form ref="form" style="width: 650px;float: left;border-right: 1px solid #e3e3e3;height: 100%;" :rules="rules" :model="form" label-width="120px">
      <el-form-item label="咨询师" prop="zUserID">

        <el-cascader v-model="form.zUserID" placeholder="请选择咨询师" :options="dropUserAll" :props="props" filterable
          clearable>
          <template slot-scope="{ node, data }">
            <span>{{ data.label }}</span>
            <span v-if="!node.isLeaf">({{ data.children.length }})</span>
          </template>
        </el-cascader>

      </el-form-item>

      <el-form-item label="排班类型" prop="SchedulType">
        <el-select v-model="form.SchedulType" placeholder="请选择排班类型">
          <el-option label="普通排班" value="0"></el-option>
          <el-option label="特殊排班" value="1"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item v-if="form.SchedulType == 0" label="排班学年" prop="SchedulYM">

        <el-select v-model="form.SchedulYM" clearable placeholder="请选择排班学年">
          <el-option v-for="item in dropOptions" :key="item.TermYM" :label="item.Types" :value="item.TermYM">
          </el-option>
        </el-select>

        <el-button type="primary" @click="drawer = true" plain style="margin-left: 20px;">
          添加学年
        </el-button>

      </el-form-item>

      <el-form-item v-if="form.SchedulType == 1" label="咨询对象" prop="DepartID">
        <el-form-item prop="bumen">
          <div class="block">
            <el-cascader ref="wcascader" v-model="form.DepartID" @change="Selected_to_shut_dow" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
          </div>
        </el-form-item>
      </el-form-item>

      <el-form-item v-if="form.SchedulType == 0" label="优先咨询对象">
        <el-form-item prop="bumen">
          <div class="block">
            <el-cascader ref="wcascader" v-model="form.Depts" @change="Selected_to_Consultationobject" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
          </div>
        </el-form-item>
      </el-form-item>

      <el-form-item label="排班日期" prop="SchedulDate">
        <el-date-picker :disabled="form.SchedulType != 1" type="daterange" value-format="yyyy-MM-dd"
          v-model="form.SchedulDate" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" unlink-panels
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      
      <!-- <el-select v-model="form.SchedulType" placeholder="请选择排班类型">
        <el-option label="普通排班" value="0"></el-option>
        <el-option label="特殊排班" value="1"></el-option>
      </el-select> -->

      <el-form-item label="咨询地点" prop="ConAddressID">
        <el-select v-model="form.ConAddressID" clearable placeholder="请选择咨询地点">
          <el-option v-for="item in ConAddressitemlist" :key="item.ConAddressID" :label="item.ConAddressName"
            :value="item.ConAddressID + '|' + item.AliasName"></el-option>
        </el-select>
        <el-button type="primary" @click="drawer1 = true" plain style="margin-left: 20px;">
          添加咨询地点
        </el-button>
      </el-form-item>

      <el-form-item label="星期" prop="Consulting_weeks">
        <el-checkbox-group v-model="form.Consulting_weeks">
          <el-checkbox-button label="周日" name="weeks"></el-checkbox-button>
          <el-checkbox-button label="周一" name="weeks"></el-checkbox-button>
          <el-checkbox-button label="周二" name="weeks"></el-checkbox-button>
          <el-checkbox-button label="周三" name="weeks"></el-checkbox-button>
          <el-checkbox-button label="周四" name="weeks"></el-checkbox-button>
          <el-checkbox-button label="周五" name="weeks"></el-checkbox-button>
          <el-checkbox-button label="周六" name="weeks"></el-checkbox-button>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="排班时间" prop="Consulting_time">
        <el-time-picker v-model="form.Consulting_time[0]" value-format="HH:mm" format="HH:mm" placeholder="排班开始时间">
        </el-time-picker>
        至
        <el-time-picker v-model="form.Consulting_time[1]" value-format="HH:mm" format="HH:mm" placeholder="排班结束时间">
        </el-time-picker>

        <!-- <el-time-picker is-range v-model="form.Consulting_time" value-format="HH:mm" format="HH:mm" range-separator="至"
            start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围" unlink-panels></el-time-picker> -->
      </el-form-item>
      <el-form-item style="position: relative;" label="咨询方式" prop="ConsultType">
        <el-checkbox-group v-model="form.ConsultType">
          <el-checkbox label="0" value="0">面对面咨询</el-checkbox>
          <el-checkbox label="1" value="1">视频咨询</el-checkbox>
        </el-checkbox-group>
        <el-button type="primary" @click="save" style="margin-left: 30px;position: absolute;top: 4px;left:220px;">
          保存时间
        </el-button>
      </el-form-item>

      <el-form-item class="save-item">
        <el-button type="success" :loading="iscontinuous"  @click="wswave('form')">保存</el-button>
        <el-button type="warning" @click="gotoSchList">返回</el-button>
      </el-form-item>

    </el-form>

    <div style="width: 1150px;float: left;">
      <h2 style="margin-left: 10px;padding-bottom: 20px;padding-left: 20px;font-size: 18px;">当前排版如下</h2>
      <div  style="margin-left: 20px;">
        <ul class="vax" v-for="(item, pindex) in weeksdata" :key="item.id">
          <li>
            <p style="height: 40px;border: 1px solid rgb(227, 227, 227);margin-left: -1px;margin-top: -1px;line-height: 40px;background-color: #f5f5f5;">{{ item.id }}</p>
            <ul class="bfv" v-for="(items, index) in item.weeks" :key="index">
              <li>
                <!-- {{ items }} -->
                <span v-if="items.split('|')[3]" style="background-color: #e1f1ff;border-radius: 5px;color: #0088FF;padding: 4px;">{{ items.split('|')[3] }}</span>
                <span>{{ items.split('|')[0] }}</span>
                <div class="udiv">
                  <span class="option" @click="del(pindex, index)">删除</span>
                  <span class="option" @click="determine(pindex, index)" style="margin-left: 5px;">修改</span>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <el-dialog class="wyu" title="修改" :visible.sync="wdialogVisible" width="40%" :before-close="handleClose">
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="排班时间">
          <el-time-picker v-model="wConsulting_time[0]" value-format="HH:mm" format="HH:mm" placeholder="排班开始时间">
          </el-time-picker>
          至
          <el-time-picker v-model="wConsulting_time[1]" value-format="HH:mm" format="HH:mm" placeholder="排班结束时间">
          </el-time-picker>
        </el-form-item>
        <el-form-item style="position: relative;" label="咨询方式">
          <el-checkbox-group v-model="pdaa">
            <el-checkbox label="0" value="0">面对面咨询</el-checkbox>
            <el-checkbox label="1" value="1">视频咨询</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="wdialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="xiugaiqued">确 定</el-button>
      </span>
    </el-dialog>
    <el-drawer title="添加学期排班" :visible.sync="drawer" :with-header="false">
      <el-form class="drawer_from" ref="form" :model="form" label-width="130px">
        <el-form-item label="学年">
          <el-col>
            <el-date-picker class="picker-150" v-model="formTermDeploy.StartYear" type="year" value-format="yyyy"
              format="yyyy" placeholder="开始"></el-date-picker>
            至
            <el-date-picker class="picker-150" v-model="formTermDeploy.EndYear" type="year" value-format="yyyy"
              format="yyyy" placeholder="结束"></el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item label="学期时间">
          <el-col>
            <el-date-picker v-model="formTermDeploy.StartDate" type="date" value-format="yyyy-MM-dd" placeholder="开始">
            </el-date-picker>
            至
            <el-date-picker v-model="formTermDeploy.FinishDate" type="date" value-format="yyyy-MM-dd" placeholder="结束">
            </el-date-picker>
          </el-col>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveTerm">立即创建</el-button>
          <el-button @click="drawer = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
    <el-drawer title="添加咨询地点" :visible.sync="drawer1" :with-header="false">
      <el-form class="drawer_from" ref="ConAddress" :rules="rules" :model="ConAddress" label-width="130px">
        <el-form-item label="咨询机构" prop="DepartID">
          <el-form-item prop="bumen">
            <div class="block">
              <el-cascader ref="wcascader" v-model="ConAddress.DepartID" @change="Selected_to_shut_dow2" @expand-change="bumen" :options="data" :props="{ checkStrictly: true }" clearable :placeholder="$t('original.languages3')"></el-cascader>
            </div>
          </el-form-item>
        </el-form-item>
        <el-form-item label="咨询室名称" prop="ConAddressName">
          <el-input maxlength="30" show-word-limit v-model="ConAddress.ConAddressName"></el-input>
        </el-form-item>
        <el-form-item label="校区" prop="campus">
          <el-select v-model="ConAddress.Campus" placeholder="请选择" @change="Campus_switching()">
            <el-option v-for="item in campus_list" :key="item.cDicEnglishValue" :label="item.cDicValue" :value="item.dicKey"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="咨询室地址" prop="Address">
          <el-input v-model="ConAddress.Address"></el-input>
        </el-form-item>
        <el-form-item label="咨询室简称" prop="AliasName">
          <el-input v-model="ConAddress.AliasName" maxlength="4"></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="ConAddress.ConName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input maxlength="11" show-word-limit v-model="ConAddress.ConTel"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveConAddress('ConAddress')">
            立即创建
          </el-button>
          <el-button @click="drawer1 = false;">取消</el-button>
        </el-form-item>
      </el-form>
    </el-drawer>
  </div>
</template>
<script>
var _this;

export default {
  data() {
    var _this = this;
    var validatorPhone = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('手机号不能为空'));
      } else if (!/^1\d{10}$/.test(value)) {
        callback(new Error('手机号格式错误'));
      } else {
        callback();
      }
    };
    var validatorSchedulYM = function (rule, value, callback) {
      if (value === '') {
        callback(new Error('选择学期排班'));
      } else {
        for (let index = 0; index < _this.dropOptions.length; index++) {
          if (_this.dropOptions[index].TermYM == value) {
            _this.form.SchedulDate = [
              _this.dropOptions[index].StartDate,
              _this.dropOptions[index].FinishDate,
            ];
          }
        }
        callback();
      }
    };

    return {
      iscontinuous:false,
      pdaa: [],
      
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        }
      },
      campus_list: [],
      data: [],
      xhaoxhax: false,
      drawer: false,
      drawer1: false,
      dropOptions: [],
      dropUserAll: [],
      props: { multiple: true, expandTrigger: 'hover' },
      ConAddressitemlist: [], //咨询地点下拉框列表
      option: [],
      pIdx: '',
      Idx: '',
      wdialogVisible: false,
      wConsulting_time: ['', ''],
      // [
      //   new Date(),
      //   new Date(new Date().getTime() + 1 * 60 * 60 * 1000),
      // ],
      options: [],
      weeksdata: [
        {
          id: '周日',
          weeks: [],
        },
        {
          id: '周一',
          weeks: [],
        },
        {
          id: '周二',
          weeks: [],
        },
        {
          id: '周三',
          weeks: [],
        },
        {
          id: '周四',
          weeks: [],
        },
        {
          id: '周五',
          weeks: [],
        },
        {
          id: '周六',
          weeks: [],
        },
      ],
      formTermDeploy: {
        StartYear: '', //学年开始
        EndYear: '', //学年结束
        StartDate: '', // 开始时间
        FinishDate: '', // 学期结束时间
        Termtime: '',
      },
      
      form: {
        zUserID: '', //咨询师编号
        SchedulYM: '', //学期ID
        ConAddressID: '', //咨询地址ID
        ConsultType: ["1"], //咨询方式
        SchedulType: '0', //发布类型
        DepartID: '', //机构地址
        Depts:'',
        SchedulDate: '', //排班日期
        Consulting_weeks: [],
        Consulting_time: ['', ''],
      },
      ConAddress: {
        //咨询师地点
        DepartID: '',
        ConAddressName: '',
        Address: '',
        ConTel: '',
        ConName: '',
        AliasName: '',
      },
      rules: {
        zUserID: [
          { required: true, message: '请选择咨询师', trigger: 'change' },
        ],
        ConsultType: [
          { required: true, message: '请选择咨询方式', trigger: 'change' },
        ],
        SchedulYM: [
          { required: true, validator: validatorSchedulYM, trigger: 'change' },
        ],
        Consulting_institutions: [
          { required: true, message: '请选择咨询方式', trigger: 'change' },
        ],
        SchedulType: [
          { required: true, message: '请选择排班类型', trigger: 'change' },
        ],
        SchedulDate: [
          { required: true, message: '请选择排班日期', trigger: 'change' },
        ],
        ConAddressID: [
          { required: true, message: '请选择咨询地点', trigger: 'change' },
        ],
        Consulting_weeks: [
          { required: true, message: '请选择星期', trigger: 'blur' },
        ],
        Consulting_time: [
          { required: true, message: '请选择排班时间', trigger: 'change' },
        ],
        ConTel: [
          { required: true, validator: validatorPhone, trigger: 'blur' },
        ],
        ConName: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        Address: [
          { required: true, message: '请输入咨询地址', trigger: 'blur' },
        ],
        ConAddressName: [
          { required: true, message: '请输入咨询室名称', trigger: 'blur' },
        ],
        AliasName: [
          { required: true, message: '请输入咨询室简称', trigger: 'blur' },
        ],
        DepartID: [
          { required: true, message: '请选择咨询机构', trigger: 'blur' },
        ],
      },
    };
  },
  components: {},
  watch: {
    // 被侦听的变量count
    'form.SchedulType'() {
      this.form.SchedulDate = ''
    }
  },
  methods: {
    drop() {
      this.$Http_Post('ConsultSubscribe/ShowTermDeploy', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dropOptions = res.Data;
        }
      });
    },
    dropGetUserAll() {
      this.$Http_Post('ConsultSubscribe/GetUserAll', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.dropUserAll = res.Data;
        }
      });
    },
    dropConAddress() {
      //咨询地点下拉框
      this.$Http_Post('ConsultSubscribe/GetConAddress', {}).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.ConAddressitemlist = res.Data;
        }
      });
    },
    saveConAddress(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$Http_Post('ConsultSubscribe/AddConAddress', {
            DepartID: this.ConAddress.DepartID,
            ConAddressName: this.ConAddress.ConAddressName,
            Address: this.ConAddress.Address,
            ConTel: this.ConAddress.ConTel,
            ConName: this.ConAddress.ConName,
            Campus: this.ConAddress.Campus,
            AliasName: this.ConAddress.AliasName
          }).then((res) => {
            if (res.Code == 200 || res.Code == 0) {
              this.drop();
              (this.drawer = false),
                this.$message({
                  type: 'success',
                  message: '添加成功',
                });
              this.drawer1 = false;
              this.dropConAddress();
            } else {
              this.$message({
                type: 'success',
                message: res.Message,
              });
            }
            this.$refs[formName].resetFields();
          });
        } else {
          return false;
        }
      });
    },

    saveTerm() {
      let message = '';
      if (this.formTermDeploy.StartYear == '' || this.formTermDeploy.EndYear == '') {
        message = '请选择学年';
      } else if (this.formTermDeploy.StartDate == '' || this.formTermDeploy.FinishDate == '') {
        message = '请选择学年时间';
      } else message = '';
      if (message == '') {
        this.$Http_Post('ConsultSubscribe/AddTermDeploy',this.formTermDeploy).then((res) => {
          if (res.Code == 200 || res.Code == 0) {
            this.drop();
            this.drawer = false;
            (this.formTermDeploy = {
              StartYear: '', //学年开始
              EndYear: '', //学年结束
              StartDate: '', // 开始时间
              FinishDate: '', // 学期结束时间
              Termtime: '',
            }),
              this.Global.request_successful('添加成功');
          } else {
            this.Global.request_failure(res.Message);
          }
        });
      } else this.Global.request_info(message);
    },
    wswave(formName) {
      if (this.weeksdata[0].weeks.length == 0) {
        this.$message({
          type: 'warning',
          message: '未保存排班时间',
        });
        return;
      }

      for (let i = 0; i < this.weeksdata.length; i++) {
        for (let index = 0; index < this.weeksdata[i].weeks.length; index++) {
          if (this.weeksdata[i].weeks[index] != '-') {
            for (let k = 0; k < 7; k++) {
              if (
                index != k &&
                this.weeksdata[i].weeks[index] == this.weeksdata[i].weeks[k]
              ) {
                this.weeksdata[i].weeks[k] = '-';
              }
            }
          }
        }
      }

      this.$refs[formName].validate((valid) => {//保存事件
        if (valid) {
          this.iscontinuous = true;
          let DepartID=JSON.parse(JSON.stringify(this.form.DepartID)).toString();
          this.$Http_Post('ConsultSubscribe/AddSchedul', {
            zUserID: this.form.zUserID, //咨询师数组
            // SchedulYM: this.form.Consulting_semester,
            ConAddressID: this.form.ConAddressID.split('|')[0],
            SchedulYM: this.form.SchedulYM,
            ConsultType: this.form.ConsultType,
            DeputID: DepartID,
            SchedulDate: this.form.SchedulDate,
            Consulting_weeks: this.form.SchedulWeek,
            weeksdata: this.weeksdata,
            SchedulType: this.form.SchedulType,
            Depts: typeof this.form.Depts == 'string' ? this.form.Depts : this.form.Depts.join(','),
          }).then((res) => {
            this.iscontinuous = false;
            if (res.Code == 200 || res.Code == 0) {
              this.drop();
              (this.drawer = false),
                this.$message({
                  type: 'success',
                  message: '添加成功',
                });
              this.$router.push('/Consultant/CalendarLayout');
            } else {
              this.$message({type: 'warning',message: res.Message,});
              
            }
          });
        } else {
          return false;
        }
      });
    },

    Selected_to_shut_dow(dt) {
      this.form.Depts = []
      this.form.DepartID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    // 普通排班咨询对象
    Selected_to_Consultationobject(dt){
      this.form.DepartID=[]
      this.form.Depts = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    Selected_to_shut_dow2(dt) {
      this.ConAddress.DepartID = dt[dt.length - 1];
      this.$refs.wcascader.dropDownVisible = false;
    },

    GetNodeByDeptID(ID, NodeList) {
      let obj = null
      for (let i = 0; i < NodeList.length; i++) {
        if (NodeList[i].DeptID == ID) {
          obj = NodeList[i]
          break
        } else if (
          NodeList[i].fuzi && NodeList[i].children.length > 0 && NodeList[i].children[0].DeptID != '-1'
        ) {
          obj = this.GetNodeByDeptID(ID, NodeList[i].children)
          if (obj != null) break
        }
      }
      return obj
    },

    bumen(dt) {
      let obj = this.data[0]
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].DeptID == dt[dt.length - 1]) {
          obj = this.data[i];
        } else if (this.data[i].fuzi && this.data[i].children.length > 0 && this.data[i].children[0].DeptID != '-1') {
          obj = this.GetNodeByDeptID(dt[dt.length - 1], this.data[i].children);
        }
      }
      let _this = this;
      if (obj.fuzi && obj.children.length > 0 && obj.children[0].DeptID == '-1') {
        obj.children = [{ label: this.$t('original.languages22') }]
        this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: dt[dt.length - 1], content: '' }).then((res) => {
          if (res.Code == 200 || res.Code == 0 && res.Data) {
            obj.children = res.Data;
          }
        })
      } else {

      }
    },


    checkTime1(start, end, start2, end2) {
      if (start == '-|') {
        return true;
      } else {

        if (Number(start2) > Number(start)) {
          return true;
        } else {
          return false;
        }


        // if (Number(start2) >= Number(end2)) {
        //   return false;
        // }
        // if (Number(end2) <= Number(start) || Number(start2) >= Number(end)) {
        //   return true;
        // } else {
        //   return false;
        // }
      }
      
    },

    save() {//保存时间事件
      // form.ConsultType

      if (!this.form.ConsultType.length >= 1) {
        this.Global.request_failure('请选择咨询方式');
        return false
      }

      if (this.form.ConAddressID == '') {
        this.Global.request_failure('请选择咨询地点');
      } else if (this.form.Consulting_weeks.length == 0) {
        this.Global.request_failure('请选择排班星期');
      } else if (this.weeksdata[0].weeks.length <= 24) {
        if ((Number(this.form.Consulting_time[1].slice(0, 2))) - Number(this.form.Consulting_time[0].slice(0, 2)) >= 1 && (Number(this.form.Consulting_time[1].slice(3, 5))) == Number(this.form.Consulting_time[0].slice(3, 5))) {//判断是否为整点
          let num = Number(this.form.Consulting_time[1].slice(0, 2)) - Number(this.form.Consulting_time[0].slice(0, 2));//间隔几个小时
          for (let j = 0; j < this.weeksdata.length; j++) {
            if (this.form.Consulting_weeks.indexOf(this.weeksdata[j].id) > -1) {//判断在不在选择的周几
              if (this.weeksdata[j].weeks.length >= 1) {//判断是不是第一次添加
                var checkTrue = true;
                for (let l = 0; l < this.weeksdata[j].weeks.length; l++) {
                  var start;
                  var end;
                  var start2;
                  var end2;

                  if (this.weeksdata[j].weeks[l].slice(1, 2) == ":") {
                    start ='0'+ this.weeksdata[j].weeks[l].slice(0, 1);
                    if (this.weeksdata[j].weeks[l].slice(6, 7) == ":") {
                      end = '0' + this.weeksdata[j].weeks[l].slice(5, 6);
                    } else {
                      end = this.weeksdata[j].weeks[l].slice(5, 7);
                    }
                  } else {

                    start = this.weeksdata[j].weeks[l].slice(0, 2);
                    end = this.weeksdata[j].weeks[l].slice(5, 7);

                  }

                  if (this.form.Consulting_time[0].slice(1, 2) == ":") {
                    start2 = '0' + this.form.Consulting_time[0].slice(0, 1);
                  } else {
                    start2 = this.form.Consulting_time[0].slice(0, 2);
                  }

                  if (this.form.Consulting_time[1].slice(1, 2) == ":") {
                    end2 = '0' + this.form.Consulting_time[1].slice(0, 1);
                  } else {
                    end2 = this.form.Consulting_time[1].slice(0, 2);
                  }

                  if (!this.checkTime1(start, end, start2, end2)) {
                    checkTrue = false;
                  }
                }

                if (checkTrue == true) {//判断时间段是否冲突
                  for (let x = 0; x < num; x++) {
                    var start1;
                    var start2;
                    start1 = Number(this.form.Consulting_time[0].slice(0, 2)) + x;
                    start2 = Number(this.form.Consulting_time[0].slice(0, 2)) + x + 1;
                    if (start1 < 10){
                      start1 = '0' + start1.toString();
                    }
                    if (start2 < 10) {
                      start2 = '0' + start2.toString();
                    }
                    this.weeksdata[j].weeks.push(start1 + ':' + this.form.Consulting_time[0].slice(3, 5) + '-' + start2 + ':' + this.form.Consulting_time[0].slice(3, 5) + '|' + this.form.ConsultType + '|' + this.form.ConAddressID);
                  }
                } else {
                  this.Global.request_failure('时间段有冲突！');
                  for (let x = 0; x < num; x++) {
                    for (let k = 0; k < j; k++) {
                      this.weeksdata[k].weeks.splice(this.weeksdata[k].weeks.length - 1, 1)
                    }
                  }
                  break;
                }
              } else {
                for (let x = 0; x < num; x++) {
                  var start1;var start2;
                  start1 = Number(this.form.Consulting_time[0].slice(0, 2)) + x;
                  start2 = Number(this.form.Consulting_time[0].slice(0, 2)) + x + 1;
                  if (start1 < 10) {
                    start1 = '0' + start1.toString();
                  }
                  if (start2 < 10) {
                    start2 = '0' + start2.toString();
                  }
                  this.weeksdata[j].weeks.push(start1 + ':' + this.form.Consulting_time[0].slice(3, 5) + '-' + start2 + ':' + this.form.Consulting_time[0].slice(3, 5) + '|' + this.form.ConsultType + '|' + this.form.ConAddressID);
                }
              }
            } else {
              for (let x = 0; x < num; x++) {
                this.weeksdata[j].weeks.push('-' + '|' + this.form.ConsultType);
              }
            }
          }
        } else {
          this.Global.request_failure('时间间隔只能为一个小时！');
        }
      } else {
        this.Global.request_failure('最多只能添加8条');
      }
    },
    fuzzy(val) { },
    csvv(a, b, c) { },
    del(pIdx, Idx) {
      this.weeksdata[pIdx].weeks[Idx] = '-';
      this.$forceUpdate();
    },
    determine(pIdx, Idx) {
      this.wdialogVisible = true;
      var time = this.weeksdata[pIdx].weeks[Idx].split('-');
      this.wConsulting_time = [time[0], time[1].split('|')[0]];
      if (time[1].substr(time[1].length - 2) == '|1') {
        this.pdaa = ['1']
      } else if (time[1].substr(time[1].length - 2) == '|0') {
        this.pdaa = ['0']
      } else if (time[1].substr(time[1].length - 2) == ',0' || time[1].substr(time[1].length - 2) == ',1') {
        this.pdaa = ['0', '1']
      }
      this.pIdx = pIdx;
      this.Idx = Idx;
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
      .then((_) => {
        done();
      })
      .catch((_) => { });
    },
    xiugaiqued() {//修改时间事件
      if (((Number(this.wConsulting_time[1].slice(0, 2))) - Number(this.wConsulting_time[0].slice(0, 2)) >= 1) && ((Number(this.wConsulting_time[1].slice(3, 5))) == Number(this.wConsulting_time[0].slice(3, 5)))) {
        this.wdialogVisible = false;
        let timestr = this.wConsulting_time[0] + '-' + this.wConsulting_time[1] + '|' + this.pdaa; //合并后时间段
        this.weeksdata[this.pIdx].weeks[this.Idx] = timestr;
        this.$forceUpdate();
      } else {
        this.Global.request_failure('时间段只能为一个小时');
      }
    },
    gotoSchList() {
      this.$router.push('/Consultant/CalendarLayout');
    },
  },
  mounted() {
    _this = this;
    this.$Http_Post('/DepartMent/GetDeprtMentByNode', { DeptID: '', content: '' }).then((res) => {
      if (res.Code == 200 || res.Code == 0 && res.Data) {
        this.data = res.Data;
        this.data2 = res.Data;
      }
    })
    this.$Http_Post('User/GetDictionaryList ', { DicTypCode: 16 }).then((res) => {
      if (res.Code == 200 || res.Code == 0) {
        this.campus_list = res.Data;
        this.ConAddress.Campus = res.Data[0].dicKey;
      }
    })
    this.drop();
    this.dropConAddress();
    this.dropGetUserAll();
  },
};
</script>
<style>
.Consultingadd{min-width: 2000px !important;}
.Consultingadd .vax{}
.Consultingadd .vax >li {
  float: left;
  width: 160px;
  text-align: center;
}
.Consultingadd .vax ul{
  border: 1px solid rgb(227, 227, 227);
  height: 40px;line-height: 40px;
  margin-top: -1px;
  margin-left: -1px;
}
.Consultingadd .bfv:hover {
  background-color: coral;
}

.Consultingadd .bfv {
  height: 22px;
  text-align: center;
  position: relative;
  border-radius: 3px;
}

.Consultingadd .bfv:hover .udiv {
  display: block;
  background-color: rgb(240, 102, 10);
  margin-left: -5px;
}

.Consultingadd .udiv {
  position: absolute;
  top: 0px;
  left: 6px;
  height: 40px;
  width: 100%;
  display: none;
  color: white;
}

.Consultingadd .udiv .option {
  padding: 2px;
  background-color: rgb(240, 102, 10);
  border-radius: 3px;
  font-size: 10px;
  cursor: pointer;
}

.wyu .el-range-editor.el-input__inner {
  width: 95%;
}

.drawer_from {
  width: 90%;
  margin: 100px 0px auto;
}
</style>
